<template>
	<div class="call-type">
		<button
			class="call-action"
			aria-haspopup="listbox"
			aria-label="Export Dropdown"
			@click.prevent.stop="onToggleClick"
		>
			<span class="call-action-icon">
				<ExportAndCopyIcon />
			</span>
			<span>Export</span>
			<font-awesome-icon
				class="ehr-move-icon"
				:icon="['fal', show ? 'chevron-up' : 'chevron-down']"
			/>
		</button>
		<transition name="fade">
			<div
				v-if="show"
				ref="dropdown"
				class="move-ehr-dropdown"
				:class="{ show }"
			>
				<div
					id="ehr-move-list"
					tabindex="-1"
					role="listbox"
					aria-label="Choose an export option"
					aria-multiselectable="true"
					class="move-ehr-dropdown-list"
					@click.stop
				>
					<div class="call-type-container">
						<div
							class="ehr-move-item"
							@click.prevent="handleDownloadPdf"
						>
							<div class="ehr-option">
								{{ downloadButtonText }}
							</div>
						</div>
						<div
							class="ehr-move-item"
							@click.prevent="handleCopySummary"
						>
							<div class="ehr-option" style="padding: 7px 14px;">
								{{ copyButtonText }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import ExportAndCopyIcon from '@/components/Icons/ExportAndCopy.vue'
export default {
	components: {
		ExportAndCopyIcon,
	},
	methods: {
		/**
		 * add Event Listeners.
		 */
		addEventListeners() {
			document.addEventListener('click', this.onOutsideClick)
			document.addEventListener('keydown', this.onEscapeKeyDown)
			this.$nextTick(this.adjustDropdownPosition)
			document.addEventListener(
				'scroll',
				this.adjustDropdownPosition,
				true
			)
		},

		adjustDropdownPosition() {
			const dropdown = this.$refs.dropdown
			if (!dropdown) return
			const parentRect = this.$el.getBoundingClientRect()
			dropdown.style.top = `${parentRect.bottom}px`
			const leftOffset = this.isPagesRoute ? -16 : 0
			dropdown.style.left = `${parentRect.left + leftOffset}px`
		},

		handleCopySummary() {
			this.emitAndCloseWithDelay('copySummary')
		},

		handleDownloadPdf() {
			this.emitAndCloseWithDelay('downloadPdf')
		},

		emitAndCloseWithDelay(eventName, delay = 2500) {
			this.$emit(eventName)
			setTimeout(() => {
				this.show = false
			}, delay)
		},

		/**
		 * Escape KeyDown event handling.
		 */
		onEscapeKeyDown() {
			if (this.show) {
				this.show = false
				this.removeEventListeners()
			}
		},

		/**
		 * onOutsideClick event handling.
		 */
		onOutsideClick(event) {
			if (this.show && !this.$el.contains(event.target)) {
				this.show = false
				this.removeEventListeners()
			}
		},

		/**
		 * onToggleClick event handling.
		 */
		onToggleClick() {
			this.show = !this.show
			this.show ? this.addEventListeners() : this.removeEventListeners()
		},

		/**
		 * remove Event Listeners.
		 */
		removeEventListeners() {
			document.removeEventListener('keydown', this.onEscapeKeyDown)
			document.removeEventListener('click', this.onOutsideClick)
			document.removeEventListener(
				'scroll',
				this.adjustDropdownPosition,
				true
			)
		},
	},
	name: 'ExportOptions',
	props: {
		copyButtonText: {
			type: String,
			required: true,
		},
		downloadButtonText: {
			type: String,
			required: true,
		},
	},

	emits: ['downloadPdf', 'copySummary'],

	created() {
		this.isPagesRoute = this.$route.name === 'app.paging.show'
	},

	beforeDestroy() {
		this.removeEventListeners()
	},

	data() {
		return {
			show: false,
			isPagesRoute: false,
		}
	},
}
</script>

<style scoped>
.move-ehr-dropdown {
	background-color: white;
	border: 1px solid rgba(0, 0, 0, 0.15);
	box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15);
	display: none;
	margin: 0.125rem 0 0;
	max-height: 18em;
	min-width: 10rem;
	position: fixed;
	z-index: 200;
	&.show {
		display: flex;
		flex-direction: column;
	}
}

.move-ehr-dropdown-list {
	background-color: white;
	color: #343a40;
	display: flex;
	flex-direction: column;
	list-style: none;
	margin: 0;
	overflow-y: auto;
	padding: 0;
	text-align: left;
	width: 100%;
}

.call-type-container {
	padding: 0;
	width: 100%;
}

.ehr-move-item {
	position: relative;
	cursor: pointer;
}

.ehr-move-item:not(:last-child)::after {
	content: '';
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 1px;
	background-color: #ccc;
}

.ehr-option {
	text-align: left;
	font-weight: 450;
	padding: 12px 16px;
	&:hover {
		background-color: #e1e1e1;
	}
}
</style>
